import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';

import defaultStyles from './palceholder-thread-row.scss';

interface Props {
    styles: typeof defaultStyles;
    key: string;
    borderTop: boolean;
}

const PlaceholderThreadRow: React.FC<Props> = props => {
    const { styles, key, borderTop } = props;

    return (
        <tr
            className={classnames(styles.thread, styles.animationWrapper, {
                [styles.borderTop]: borderTop,
            })}
            key={key}
        >
            <td>
                <div className={classnames(styles.filler, styles.filler1)} />
                <div className={classnames(styles.filler, styles.filler2)} />
                <div className={classnames(styles.filler, styles.filler3)} />
                <div className={classnames(styles.filler, styles.filler4)} />
                <div className={classnames(styles.filler, styles.filler5)} />
                <div className={classnames(styles.filler, styles.filler6)} />
                <div className={classnames(styles.filler, styles.filler7)} />
                <div className={classnames(styles.filler, styles.filler8)} />
            </td>

            <td className={styles.title} />
            <td className={styles.stats} />
            <td className={styles.contributors} />
            <td className={styles.likes} />
            <td className={styles.linksWrapper}>
                <span />
                <br />
            </td>
        </tr>
    );
};

export default Styled(defaultStyles)(PlaceholderThreadRow);
